/* global ajax_params */

export function AsyncPost(data) {
  let ajax_url = ajax_params.url;
  let body = '';

  for (let key in data) {
    body += key + '=' + data[key] + '&';
  }

  return fetch(ajax_url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded',
    }),
    body: body,
  }).then((resp) => resp.json());
}
